import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const links = [
  { id: "capsule", label: "Capsule" },
  { id: "acronym", label: "R.I.V.H" },
  { id: "manifesto", label: "Manifesto" },
  { id: "showroom", label: "Showroom" },
  { id: "register", label: "Register" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jump = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.nav
      data-testid="site-nav"
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 2.4 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 py-5">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="x-mark text-2xl md:text-3xl text-white tracking-tight"
        >
          X
        </button>

        <ul className="hidden md:flex items-center gap-10 font-mono text-[11px] uppercase tracking-[0.25em]">
          {links.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`nav-link-${l.id}`}
                onClick={() => jump(l.id)}
                className="text-white/70 hover:text-white transition-colors duration-300"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          data-testid="nav-cta"
          onClick={() => jump("register")}
          className="hidden md:inline-flex btn-sharp"
        >
          <span>Enter The List</span>
        </button>

        <button
          data-testid="nav-cta-mobile"
          onClick={() => jump("register")}
          className="md:hidden font-mono text-[10px] uppercase tracking-[0.25em] text-white border-b border-white/60"
        >
          The List
        </button>
      </div>
    </motion.nav>
  );
}
